import { AfterViewInit, Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActNowDictionaryItem, KeyValueModel } from "@models/common";
import { Router, NavigationStart } from "@angular/router";
import {
    Legend,
    JsonShapeUrls,
    StateMapRequest,
    StateMapResponse,
    AreaDetail,
    ShapeColorOptions,
    AreaMapRequest,
    MapProgram,
    MapType,
    PovertyMapRequest,
    LegendKey,
    RaceEthnicityMapRequest,
    AreaDetailWithData,
    AdditionalMapFilter,
    EducationalAttainmentMapRequest,
    RaceEthnicityMapFilter,
    EducationalAttainmentMapFilter,
    PovertyMapFilter,
    EmploymentMapFilter,
    EmploymentMapRequest,
    HousingMapFilter,
    HousingMapRequest,
} from "@models/map";
import { DataTable } from "primeng/primeng";
import { DataTablePaginator } from "../common/datatable-paginator/datatable-paginator.component";
import { MapService } from "./map.service";
import { MapValuesService } from "./map-values.service";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
declare var google: any;
declare var jQuery: any;

@Component({
    templateUrl: "./map.component.html"
})
export class MapComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild("map") mapElement;
    @ViewChild("legendElement") legendElement;
    // Select Elements
    @ViewChild("areaSelectElement") areaSelectElement;
    @ViewChild("gradeSelectElement") gradeSelectElement;
    @ViewChild("programSelectElement") programSelectElement;
    @ViewChild("programsListElement") programsListElement;

    @ViewChild("additionalMapFiltersElement") additionalMapFiltersElement;

    @ViewChild("dt") dt: DataTable;
    @ViewChild("dtp") dtp: DataTablePaginator;
    // Selectize Objects
    public loading = true;
    public areaSelectize: any;
    public gradeSelectize: any;
    public programSelectize: any;
    public mapLibLoaded = false;
    public map: any;
    public shapeUrls: JsonShapeUrls = new JsonShapeUrls();
    public features: any[];
    public stateinfowindow: any;
    public areainfowindow: any;
    public markers: any[] = [];
    public markerListeners: any[] = [];
    public stateMapListener: any;
    public chartPrograms: MapProgram[];

    public selectedAreaType: ActNowDictionaryItem;
    public currentAreaType: ActNowDictionaryItem;
    public defaultAreaType: ActNowDictionaryItem;
    public selectedGrades: ActNowDictionaryItem[] = [];
    public selectedPrograms: ActNowDictionaryItem[] = [];

    public selectedValues: any = {};

    public legend: Legend;
    public hideLegend = true;
    public zoomedIn = false;
    public areaId: number;
    public initZoomed = false;
    public rowCount = 10;
    public mapRows = 10;

    public mapType: MapType = MapType.State;
    public MapTypes = MapType;
    public additionalMapFilters: { type: MapType, filters: AdditionalMapFilter[]}[];

    public routerSub: Subscription;
    public mapIcons = {
        pinRed: {
            icon: "../../assets/images/pin-red.png"
        },
        pinGreen: {
            icon: "../../assets/images/pin-green.png"
        }
    };

    public searchbarSub: Subscription;

    constructor(private title: Title, private mapService: MapService, private valueService: MapValuesService, private router: Router) {
        this.routerSub = this.router.events.filter(x => x instanceof NavigationStart).subscribe((e: NavigationStart) => {
            if (e.url === "/request-addition") {
                let model = this.getFilters();
                localStorage.setItem("map-filters", JSON.stringify(model));
            }
        });
    }

    ngOnDestroy(): void {
        this.routerSub.unsubscribe();
        this.searchbarSub.unsubscribe();
    }

    ngOnInit(): void {
        this.title.setTitle("ActNow Illinois - Map");
        this.defaultAreaType = this.valueService.areaOptions.find(x => x.id === 3);
        this.searchbarSub = this.valueService.updateMap$.subscribe(x => {
            this.updateMapFromSearchbar(x);
        });

        let existing = localStorage.getItem("map-filters");
        localStorage.removeItem("map-filters");
        if (existing != undefined) {
            // do stuff with model here then delete it from local storage
            let model = <AreaMapRequest>JSON.parse(existing);
            let areaTypeId = model.areaType;
            let areaType = this.valueService.areaOptions.find(x => x.id === areaTypeId);
            this.selectedAreaType = areaType;
            this.currentAreaType = areaType;

            let grades = [];
            model.grades.forEach(value => {
                let num = +value;
                grades.push(num);
            });

            grades.sort((a, b) => a - b);

            grades.forEach(x => {
                let option = this.valueService.gradeOptions.find(o => o.id === x);
                this.selectedGrades.push(option);
            });

            let prog = [];
            model.programsOffered.forEach(value => {
                let num = +value;
                prog.push(num);
            });

            prog.sort((a, b) => a - b);

            prog.forEach(x => {
                let option = this.valueService.programOptions.find(o => o.id === x);
                this.selectedPrograms.push(option);
            });

            if (model.id != undefined) {
                this.areaId = model.id;
                this.initZoomed = true;
            }
        } else {
            this.selectedAreaType = this.defaultAreaType;
            this.currentAreaType = this.defaultAreaType;
        }

        this.additionalMapFilters = [
            {
                type: MapType.Poverty,
                filters: this.valueService.povertyFilters
            },
            {
                type: MapType.RaceEthnicity,
                filters: this.valueService.raceEthnicityFilters
            },
            {
                type: MapType.EducationalAttainment,
                filters: this.valueService.educationalAttainmentFilters
            },
            {
                type: MapType.Employment,
                filters: this.valueService.employmentFilters
            },
            {
                type: MapType.Housing,
                filters: this.valueService.housingFilters
            },
        ]
    }

    ngAfterViewInit(): void {
        this.checkForMapLibAndInit();
        this.createSelects();
        this.removeJQueryPopoverListeners();
    }

    checkForMapLibAndInit(i: number = 0): void {
        if (this.mapLibLoaded) {
            this.initMap();
        } else {
            if (i < 300) {
                i++;
                if (typeof (window.google) !== "undefined") {
                    if (typeof (window.google.maps) !== "undefined") {
                        this.mapLibLoaded = true;
                        this.initMap();
                    } else {
                        this.mapLibLoaded = false;
                        setTimeout(() => this.checkForMapLibAndInit(i), 100);
                    }
                } else {
                    setTimeout(() => this.checkForMapLibAndInit(i), 100);
                }
            }
        }
    }

    changeMap(type: MapType) {
        if (!this.zoomedIn) {
            this.mapType = type;
            this.updateMap();
        }
    }

    createFilterSelect(selectedKey: string, options: any, selectElement: any, defaultValue: any = '', valueField = 'value', textField = 'key'): any {
        this.selectedValues[selectedKey] = options.find(x => x[valueField] == defaultValue);
        return jQuery(selectElement).selectize({
            options: options,
            valueField: valueField,
            labelField: textField,
            items: [this.selectedValues[selectedKey][valueField]],
            onChange: (value) => {
                this.selectedValues[selectedKey] = options.find(x => x[valueField] == value);
            }
        });
    }

    createFilterSelects(filters: AdditionalMapFilter[]) {
        var ctx = this;
        filters.forEach((filter: AdditionalMapFilter) => {
            ctx.createFilterSelect(filter.key, filter.options, ctx.additionalMapFiltersElement.nativeElement.querySelector(`.${filter.key}`), filter.defaultValue);
        });
    }

    createSelects(): void {
        this.areaSelectize = jQuery(this.areaSelectElement.nativeElement).selectize({
            options: this.valueService.areaOptions,
            valueField: "id",
            items: [this.currentAreaType.id],
            onChange: (id) => {
                this.handleAreaChange(id);
            }
        });
        this.gradeSelectize = jQuery(this.gradeSelectElement.nativeElement).selectize({
            options: this.valueService.gradeOptions,
            items: this.selectedGrades,
            maxItems: null,
            closeAfterSelect: true,
            valueField: "id",
            placeholder: "Select an Option",
            onChange: (values) => {
                this.handleGradeChange(values);
            },
            onDropdownClose: (dd) => {
                jQuery(dd).prev().find("input").blur();
            },
            render: {
                item: (item, escape) => {
                    return false;
                }
            }
        });
        this.programSelectize = jQuery(this.programSelectElement.nativeElement).selectize({
            options: this.valueService.programOptions,
            items: this.selectedPrograms,
            maxItems: null,
            closeAfterSelect: true,
            valueField: "id",
            placeholder: "Select an Option",
            onChange: (values) => {
                this.handleProgramChange(values);
            },
            onDropdownClose: (dd) => {
                jQuery(dd).prev().find("input").blur();
            },
            render: {
                item: (item, escape) => {
                    return false;
                }
            }
        });

        this.additionalMapFilters.forEach((value) => {
            this.createFilterSelects(value.filters);
        })
    }

    handleAreaChange(value: number) {
        value = +value;
        this.selectedAreaType = this.valueService.areaOptions.find(x => x.id === value);
    }

    gen() {
        let val = this.selectedAreaType.id;
        this.mapService.generateShapes(val).subscribe(
            result => console.log("generated shapes for id", val)
        );
    }

    handleGradeChange(values: string[]) {
        let ids: number[] = [];
        values.forEach(value => {
            let num = +value;
            ids.push(num);
        });

        ids.sort((a, b) => a - b);

        this.selectedGrades = [];

        ids.forEach(x => {
            let option = this.valueService.gradeOptions.find(o => o.id === x);
            this.selectedGrades.push(option);
        });
    }

    handleProgramChange(values: any) {
        let ids: number[] = [];
        values.forEach(value => {
            let num = +value;
            ids.push(num);
        });

        ids.sort((a, b) => a - b);
        this.selectedPrograms = [];
        ids.forEach(x => {
            let option = this.valueService.programOptions.find(p => p.id === x);
            this.selectedPrograms.push(option);
        });
    }

    deselectGrade(id: number) {
        let idx = this.selectedGrades.map((x) => x.id).indexOf(id);
        this.selectedGrades.splice(idx, 1);

        this.gradeSelectize[0].selectize.setValue(this.selectedGrades.map(x => x.id), false);
    }

    deselectProgram(id: number) {
        let idx = this.selectedPrograms.map(x => x.id).indexOf(id);
        this.selectedPrograms.splice(idx, 1);

        this.programSelectize[0].selectize.setValue(this.selectedPrograms.map(x => x.id), false);
    }

    initMap(): void {
        this.map = new google.maps.Map(this.mapElement.nativeElement, {
            center: this.valueService.mapCenter,
            zoom: this.valueService.stateZoom,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
            fullscreenControlOptions: { position: google.maps.ControlPosition.TOP_LEFT },
        });
        this.stateinfowindow = new google.maps.InfoWindow({
            content: ""
        });
        this.areainfowindow = new google.maps.InfoWindow({
            content: "",
            pixelOffset: new google.maps.Size(0, -26)
        });
        this.map.data.setStyle(this.valueService.baseShapeOpts);
        this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(this.legendElement.nativeElement);
        this.addStateShapeClickListener();
        this.stateinfowindow.addListener("closeclick", (event: any) => {
            this.removeJQueryPopoverListeners();
        });
        this.areainfowindow.addListener("closeclick", (event: any) => {
            this.removeAreaJQueryPopoverListeners();
        });
        if (this.initZoomed) {
            this.getShapes(this.attemptZoomIn(this.areaId));
        } else {
            this.getShapes(this.updateStateMap());
        }

        google.maps.event.addListener(this.areainfowindow, "closeclick", () => this.onAreaInfoWindowClose());
    }

    addStateShapeClickListener(): void {
        this.stateMapListener = this.map.data.addListener("click", (event: any) => {
            this.handleClick(event);
        });
    }
    removeStateMapListener(): void {
        google.maps.event.removeListener(this.stateMapListener);
        this.stateMapListener = undefined;
    }

    addAreaMarkerClickListener(marker: any): void {
        marker.addListener("click", (event: any) => {
            this.openInfoWindowForMarker(marker);
        });
    }

    removeMarkerListeners(): void {
        this.markerListeners.forEach(x => {
            google.maps.event.removeListener(x);
        });

        this.markerListeners = [];
    }

    getShapes(callback?): void {
        let url: string;
        switch (this.selectedAreaType.id) {
            case 1:
                url = this.shapeUrls.zip;
                break;
            case 2:
                url = this.shapeUrls.city;
                break;
            case 3:
                url = this.shapeUrls.county;
                break;
            case 4:
                url = this.shapeUrls.fhd;
                break;
            case 5:
                url = this.shapeUrls.shd;
                break;
            case 6:
                url = this.shapeUrls.ssd;
                break;
            case 7:
                url = this.shapeUrls.idhs;
                break;
        }

        if (url == undefined) {
            this.mapService.getShapes(this.selectedAreaType.id).subscribe(
                response => {
                    let byteString = atob(response);
                    let ab = new ArrayBuffer(byteString.length);
                    let ia = new Uint8Array(ab);
                    for (let i = 0; i < byteString.length; i++) {
                        ia[i] = byteString.charCodeAt(i);
                    }
                    let blob = new Blob([ab], { type: "application/json" });
                    url = window.URL.createObjectURL(blob);
                    switch (this.selectedAreaType.id) {
                        case 1:
                            this.shapeUrls.zip = url;
                            break;
                        case 2:
                            this.shapeUrls.city = url;
                            break;
                        case 3:
                            this.shapeUrls.county = url;
                            break;
                        case 4:
                            this.shapeUrls.fhd = url;
                            break;
                        case 5:
                            this.shapeUrls.shd = url;
                            break;
                        case 6:
                            this.shapeUrls.ssd = url;
                            break;
                        case 7:
                            this.shapeUrls.idhs = url;
                            break;
                    }
                    this.loadShapes(url, callback);
                }
            );
        } else {
            this.loadShapes(url, callback);
        }
    }

    loadShapes(url: string, callback?): void {
        this.map.data.loadGeoJson(url, { idPropertyName: "id" }, callback);
    }

    updateMap(): void {
        setTimeout(() => this.loading = true);
        if (this.zoomedIn) {
            this.updateAreaMap();
        } else {
            this.updateStateMap();
        }
    }

    updateStateMap(): void {
        // hide the legend
        this.hideLegend = true;

        // set the shapes back to gray
        this.setShapesToDefault();

        // close the info window if its still hanging around
        this.closeStateInfoWindow();

        if (this.areaSelectize && this.areaSelectize[0]) {
            if (this.mapType == MapType.State) {
                this.areaSelectize[0].selectize.enable();
            } else {
                this.areaSelectize[0].selectize.disable();
                this.areaSelectize[0].selectize.setValue(this.defaultAreaType.id, false);
            }
        }

        // load new shapes if area changed
        if (this.currentAreaType.id !== this.selectedAreaType.id) {
            // remove current shapes
            this.map.data.forEach(x => {
                this.map.data.remove(x);
            });

            // set the current area type, fetch the shapes and try again once thats done
            this.currentAreaType = this.selectedAreaType;
            this.getShapes(this.updateStateMap());
            return;
        }

        let programs = this.getProgramFilterIds();
        let grades = this.getGradeFilterIds();

        let getData$: Observable<StateMapResponse>;

        switch(this.mapType) {
            case MapType.State:
                getData$ = this.mapService.filterStateMap({
                    programsOffered: programs,
                    grades: grades,
                    areaType: this.selectedAreaType.id
                } as StateMapRequest);
                break;
            case MapType.Poverty:
                getData$ = this.mapService.filterPovertyMap({
                    programsOffered: programs,
                    grades: grades,
                    areaType: this.selectedAreaType.id,
                    age: +(<KeyValueModel>this.selectedValues[PovertyMapFilter.Age]).value,
                    type: +(<KeyValueModel>this.selectedValues[PovertyMapFilter.Type]).value
                } as PovertyMapRequest);
                break;
            case MapType.RaceEthnicity:
                getData$ = this.mapService.filterRaceEthnicityMap({
                    programsOffered: programs,
                    grades: grades,
                    areaType: this.selectedAreaType.id,
                    year: (<KeyValueModel>this.selectedValues[RaceEthnicityMapFilter.Year]).value,
                    race: (<KeyValueModel>this.selectedValues[RaceEthnicityMapFilter.Race]).value,
                    ageGroup: (<KeyValueModel>this.selectedValues[RaceEthnicityMapFilter.Age]).value,
                    sex: (<KeyValueModel>this.selectedValues[RaceEthnicityMapFilter.Sex]).value,
                } as RaceEthnicityMapRequest);
                break;
            case MapType.EducationalAttainment:
                getData$ = this.mapService.filterEducationalAttainmentMap({
                    programsOffered: programs,
                    grades: grades,
                    areaType: this.selectedAreaType.id,
                    year: (<KeyValueModel>this.selectedValues[EducationalAttainmentMapFilter.Year]).value,
                } as EducationalAttainmentMapRequest);
                break;
            case MapType.Employment:
                getData$ = this.mapService.filterEmploymentMap({
                    programsOffered: programs,
                    grades: grades,
                    areaType: this.selectedAreaType.id,
                    field: +(<KeyValueModel>this.selectedValues[EmploymentMapFilter.Field]).value,
                    year: (<KeyValueModel>this.selectedValues[EmploymentMapFilter.Year]).value,
                } as EmploymentMapRequest);
                break;
            case MapType.Housing:
                getData$ = this.mapService.filterHousingMap({
                    programsOffered: programs,
                    grades: grades,
                    areaType: this.selectedAreaType.id,
                    field: (<KeyValueModel>this.selectedValues[HousingMapFilter.Field]).value,
                } as HousingMapRequest);
                break;
        }

        getData$.finally(() => setTimeout(() => this.loading = false)).subscribe(
            response => {
                this.updateShapes(response.areaDetails);
                this.updateLegend(response.legend);
            }
        );
    }

    getGradeFilterIds(): number[] {
        let grades: number[] = [];
        this.selectedGrades.forEach(x => {
            grades.push(x.id);
        });

        return grades;
    }

    getCurrentMapName(): string {
        switch (this.mapType) {
            case MapType.State:
                return "State";
            case MapType.Poverty:
                return "Poverty";
            case MapType.RaceEthnicity:
                return "Race/Ethnicity";
            case MapType.EducationalAttainment:
                return "Educational Attainment";
            case MapType.Employment:
                return "Employment";
            case MapType.Housing:
                return "Housing";
            default:
                return "";
        }
    }

    getCurrentLegendValue(): string {
        switch (this.mapType) {
            case MapType.State:
                return "Programs";
            case MapType.Poverty:
                return (<KeyValueModel>this.selectedValues[PovertyMapFilter.Type]).key;
            case MapType.RaceEthnicity:
                return 'People';
            case MapType.EducationalAttainment:
                return "Points";
            case MapType.Employment:
                return (<KeyValueModel>this.selectedValues[EmploymentMapFilter.Field]).key;
            case MapType.Housing:
                return (<KeyValueModel>this.selectedValues[HousingMapFilter.Field]).key;
            default:
                return "";
        }
    }

    getProgramFilterIds(): number[] {
        let programs: number[] = [];
        this.selectedPrograms.forEach(x => {
            programs.push(x.id);
        });

        return programs;
    }

    getStateMapFilters(): StateMapRequest {
        return null;
    }

    closeStateInfoWindow(): void {
        this.stateinfowindow.close();
        this.removeJQueryPopoverListeners();
    }

    updateShapes(details: AreaDetail[], retries: number = 0) {
        let broken = false;
        const circleIcon = {
            path: google.maps.SymbolPath.CIRCLE,
            fillOpacity: 1,
            fillColor: '#fff',
            strokeOpacity: 1,
            strokeWeight: 1,
            strokeColor: '#333',
            scale: 12
          };
        this.removeMarkers();
        for (let i = 0; i < details.length; i++) {
            let detail = details[i];
            let feature = this.map.data.getFeatureById(detail.id);

            if (feature == undefined) {
                broken = true;
                break;
            }

            //total programs badge if area type county
            if (this.selectedAreaType && this.selectedAreaType.id == this.defaultAreaType.id && this.mapType != MapType.State) {
                let bounds = new google.maps.LatLngBounds();
                feature.getGeometry().getArray().forEach(path => {
                    path.getArray().forEach(latlng => {
                        bounds.extend(latlng);
                    });
                });
                let marker = new google.maps.Marker({
                    position: bounds.getCenter(),
                    icon: circleIcon,
                    label: {
                        color: '#000', fontSize: '12px', fontWeight: '600',
                        text: detail.totalPrograms.toString()
                    }
                });
                marker.addListener("click", (event: any) => {
                    this.handleClick({
                        feature, latLng: event.latLng
                    });
                });
                marker.setMap(this.map);
                this.markers.push(marker);
            }
            //--

            feature.setProperty("totalPrograms", detail.totalPrograms);
            feature.setProperty("legendKey", detail.legendKey);
            this.setFeatureData(feature, detail);
        }

        if (!broken) {
            this.map.data.setStyle((x) => {
                let legend = +x.getProperty("legendKey");
                let style: ShapeColorOptions = this.getMapShapeOpts(legend);
                return style;
            });
        }



        if (broken && retries < 100) {
            setTimeout(() => this.updateShapes(details, retries++), 200);
        }
    }

    setFeatureData(feature: any, detail: AreaDetail){
        switch (this.mapType) {
            case MapType.Poverty:
            case MapType.RaceEthnicity:
            case MapType.EducationalAttainment:
            case MapType.Employment:
            case MapType.Housing:
                feature.setProperty("data", (<AreaDetailWithData>detail).data);
                break;
        }
    }

    setShapesToDefault(): void {
        this.map.data.setStyle(this.valueService.baseShapeOpts);
        this.map.data.forEach(x => {
            x.removeProperty("totalPrograms");
            x.removeProperty("legendKey");
            x.removeProperty("data");
        });
    }

    updateLegend(legend: Legend) {
        if (this.legend == undefined) {
            this.legend = new Legend();
        }
        this.legend.hi = legend.hi;
        this.legend.midHi = legend.midHi;
        this.legend.midLo = legend.midLo;
        this.legend.lo = legend.lo;
        this.legend.value = this.getCurrentLegendValue();
        this.updateLegendColor();

        setTimeout(() => this.hideLegend = false, 0);
    }

    updateLegendColor() {
        this.legend.hi.color = this.getMapShapeOpts(LegendKey.Hi).fillColor;
        this.legend.midHi.color = this.getMapShapeOpts(LegendKey.MidHi).fillColor;
        this.legend.midLo.color = this.getMapShapeOpts(LegendKey.MidLo).fillColor;
        this.legend.lo.color = this.getMapShapeOpts(LegendKey.Lo).fillColor;
    }

    getMapShapeOpts(type: LegendKey): ShapeColorOptions {
        var opts: ShapeColorOptions = new ShapeColorOptions(this.valueService.baseShapeOpts);
        switch (type) {
            case LegendKey.Lo:
                opts = new ShapeColorOptions(this.valueService.loShapeOpts);
                switch (this.mapType) {
                    case MapType.Poverty:
                        opts.fillColor = this.valueService.povertyLoShapeColor;
                        opts.strokeColor = this.valueService.povertyShapeStrokeColor;
                        break;
                    case MapType.RaceEthnicity:
                        opts.fillColor = this.valueService.raceEthnicityLoShapeColor;
                        opts.strokeColor = this.valueService.raceEthnicityShapeStrokeColor;
                        break;
                    case MapType.EducationalAttainment:
                        opts.fillColor = this.valueService.educationalAttainmentLoShapeColor;
                        opts.strokeColor = this.valueService.educationalAttainmentShapeStrokeColor;
                        break;
                    case MapType.Employment:
                        opts.fillColor = this.valueService.employmentLoShapeColor;
                        opts.strokeColor = this.valueService.employmentShapeStrokeColor;
                        break;
                    case MapType.Housing:
                        opts.fillColor = this.valueService.housingLoShapeColor;
                        opts.strokeColor = this.valueService.housingShapeStrokeColor;
                        break;
                }
                break;
            case LegendKey.MidLo:
                opts = new ShapeColorOptions(this.valueService.midLoShapeOpts);
                switch (this.mapType) {
                    case MapType.Poverty:
                        opts.fillColor = this.valueService.povertyMidLoShapeColor;
                        opts.strokeColor = this.valueService.povertyShapeStrokeColor;
                        break;
                    case MapType.RaceEthnicity:
                        opts.fillColor = this.valueService.raceEthnicityMidLoShapeColor;
                        opts.strokeColor = this.valueService.raceEthnicityShapeStrokeColor;
                        break;
                    case MapType.EducationalAttainment:
                        opts.fillColor = this.valueService.educationalAttainmentMidLoShapeColor;
                        opts.strokeColor = this.valueService.educationalAttainmentShapeStrokeColor;
                        break;
                    case MapType.Employment:
                        opts.fillColor = this.valueService.employmentMidLoShapeColor;
                        opts.strokeColor = this.valueService.employmentShapeStrokeColor;
                        break;
                    case MapType.Housing:
                        opts.fillColor = this.valueService.housingMidLoShapeColor;
                        opts.strokeColor = this.valueService.housingShapeStrokeColor;
                        break;
                }
                break;
            case LegendKey.MidHi:
                opts = new ShapeColorOptions(this.valueService.midHiShapeOpts);
                switch (this.mapType) {
                    case MapType.Poverty:
                        opts.fillColor = this.valueService.povertyMidHiShapeColor;
                        opts.strokeColor = this.valueService.povertyShapeStrokeColor;
                        break;
                    case MapType.RaceEthnicity:
                        opts.fillColor = this.valueService.raceEthnicityMidHiShapeColor;
                        opts.strokeColor = this.valueService.raceEthnicityShapeStrokeColor;
                        break;
                    case MapType.EducationalAttainment:
                        opts.fillColor = this.valueService.educationalAttainmentMidHiShapeColor;
                        opts.strokeColor = this.valueService.educationalAttainmentShapeStrokeColor;
                        break;
                    case MapType.Employment:
                        opts.fillColor = this.valueService.employmentMidHiShapeColor;
                        opts.strokeColor = this.valueService.employmentShapeStrokeColor;
                        break;
                    case MapType.Housing:
                        opts.fillColor = this.valueService.housingMidHiShapeColor;
                        opts.strokeColor = this.valueService.housingShapeStrokeColor;
                        break;
                }
                break;
            case LegendKey.Hi:
                opts = new ShapeColorOptions(this.valueService.hiShapeOpts);
                switch (this.mapType) {
                    case MapType.Poverty:
                        opts.fillColor = this.valueService.povertyHiShapeColor;
                        opts.strokeColor = this.valueService.povertyShapeStrokeColor;
                        break;
                    case MapType.RaceEthnicity:
                        opts.fillColor = this.valueService.raceEthnicityHiShapeColor;
                        opts.strokeColor = this.valueService.raceEthnicityShapeStrokeColor;
                        break;
                    case MapType.EducationalAttainment:
                        opts.fillColor = this.valueService.educationalAttainmentHiShapeColor;
                        opts.strokeColor = this.valueService.educationalAttainmentShapeStrokeColor;
                        break;
                    case MapType.Employment:
                        opts.fillColor = this.valueService.employmentHiShapeColor;
                        opts.strokeColor = this.valueService.employmentShapeStrokeColor;
                        break;
                    case MapType.Housing:
                        opts.fillColor = this.valueService.housingHiShapeColor;
                        opts.strokeColor = this.valueService.housingShapeStrokeColor;
                        break;
                }
                break;
        }
        return opts;
    }

    handleClick(event: any): void {
        this.closeAreaInfoWindow();
        // Populate the info window
        let content = this.generateAreaPopoverContent(event.feature);
        this.stateinfowindow.setContent(content);

        // Set its position
        let lat = event.latLng.lat();
        let lng = event.latLng.lng();
        this.stateinfowindow.setPosition({ lat: lat, lng: lng });

        // Open it
        this.stateinfowindow.open(this.map);
        this.addJQueryPopoverListeners();
    }

    generateAreaPopoverContent(feature: any): string {
        let id = feature.getProperty("id");
        let name = feature.getProperty("name");
        let programCount = feature.getProperty("totalPrograms");

        let content = "<div id='content'>";
        content += "<h1><a class='zoom-in-click-target' data-area-id='" + id + "'>" + name + "</a></h1>";

        let loaded = programCount != undefined;
        if (!loaded) {
            content += "<p>Area details are currently loading. Please Wait.</p>";
        } else {
            if (programCount > 0) {
                content += "<p>Total Programs: " + programCount + "</p>";
                if (!this.zoomedIn) {
                    content += "<p><a class='zoom-in-click-target' data-area-id='" + id + "'>Zoom In</a></p>";
                }
            } else {
                content += "<p>No progams have been added to this area that meet the filtering criteria.</p>";
                content += "<p>Add the first program by clicking the link below!</p>";
                content += "<p><a class='add-program-click-target'>Add a Program</a></p>";
            }
			content += "<br>";
			content += this.getAreaPopoverMapTypeContent(feature, content);
        }

        content += "</div>";

        return content;
    }

    getAreaPopoverMapTypeContent(feature: any, content: string): string {
        var content = '<table class="map-popup-table"><tbody>';
        switch (this.mapType) {
            case MapType.Poverty:
                var data = <KeyValueModel[]>feature.getProperty("data");
                if (data != null && data.length) {
                    content += "<tr><td colspan='2'><b>All Ages</b></td></tr>";
                    for (let i = 0; i < 6; i++) {
                        content += `<tr><td>${data[i].key}</td><td>${this.formatDecimal(data[i].value)}</td></tr>`;
                    }
                    content += "<tr><td colspan='2'><b>Age 0-17</b></td></tr>";
                    for (let i = 6; i < 12; i++) {
                        content += `<tr><td>${data[i].key}</td><td>${this.formatDecimal(data[i].value)}</td></tr>`;
                    }
                    content += "<tr><td colspan='2'><b>Age 5-17 in Families</b></td></tr>";
                    for (let i = 12; i < 18; i++) {
                        content += `<tr><td>${data[i].key}</td><td>${this.formatDecimal(data[i].value)}</td></tr>`;
                    }
                }
                break;
            case MapType.RaceEthnicity:
            case MapType.EducationalAttainment:
            case MapType.Employment:
            case MapType.Housing:
                var data = <KeyValueModel[]>feature.getProperty("data");
                if (data != null && data.length) {
                    for (let i = 0; i < data.length; i++) {
                        content += `<tr><td>${data[i].key}</td><td>${this.formatDecimal(data[i].value)}</td></tr>`;
                    }
                }
                break;
        }
        content += '</tbody></table><br><br>';
        return content;
    }

    formatDecimal(value: string): number {
        return parseFloat(parseFloat(value).toFixed(2));
    }

    relegend(): void {
        this.hideLegend = false;
        if (this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].getArray().length > 0) {
            this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].clear();
        } else {
            this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(this.legendElement.nativeElement);
        }
    }

    addJQueryPopoverListeners() {
        jQuery(".add-program-click-target").on("click", (e) => {
            this.router.navigate(["request-addition"]);
        });
        jQuery(".zoom-in-click-target").on("click", (e) => {
            setTimeout(() => this.loading = true);
            let id = jQuery(e.target).data().areaId;
            this.zoomIn(id);
        });
    }

    removeJQueryPopoverListeners() {
        jQuery(".add-program-click-target").off("click");
        jQuery("zoom-in-click-target").off("click");
    }

    attemptZoomIn(id: number, attempts: number = 0): void {
        let any = false;
        this.map.data.forEach(x => {
            if (x != undefined) {
                any = true;
                return;
            }
        });

        if (any) {
            this.zoomIn(id);
        } else if (attempts < 100) {
            attempts++;
            setTimeout(() => this.attemptZoomIn(id, attempts), 300);
        } else {
            console.log("failed to zoom in");
        }
    }


    zoomIn(id: number): void {
        this.zoomedIn = true;
        this.areaId = id;
        this.hideLegend = true;
        setTimeout(() => {
            this.removeStateMapListener();
            this.closeStateInfoWindow();
            this.map.data.forEach(x => {
                let shapeId: number = x.getProperty("id");
                if (shapeId !== id) {
                    this.map.data.remove(x);
                } else {
                    let bounds = new google.maps.LatLngBounds();
                    let feature = this.map.data.getFeatureById(id);
                    feature.getGeometry().getArray().forEach(path => {
                        path.getArray().forEach(latlng => {
                            bounds.extend(latlng);
                        });
                    });

                    if (this.mapType == MapType.State) {
                        this.map.data.setStyle(this.valueService.zoomShapeOpts);
                    } else {
                        this.addStateShapeClickListener();
                    }

                    this.map.fitBounds(bounds);

                    this.updateAreaMap();

                }
            });
        });
    }

    zoomOut(): void {
        setTimeout(() => this.loading = true);
        this.zoomedIn = false;
        this.rowCount = 10;
        this.mapRows = 10;
        this.removeMarkers();
        this.closeAreaInfoWindow();
        setTimeout(() => {
            this.removeStateMapListener();
            this.addStateShapeClickListener();
            this.removeMarkers();
            this.map.data.forEach(x => {
                this.map.data.remove(x);
            });
            this.map.setCenter(this.valueService.mapCenter);
            this.map.setZoom(this.valueService.stateZoom);
            this.getShapes(this.updateStateMap());
        });
    }

    updateAreaMap(): void {
        this.removeMarkers();
        // destroy the old datatable. get it out of here
        // remove anything else that needs removing

        // check if they changed area types if they did, zoom them out and stop with this logic
        if (this.currentAreaType.id !== this.selectedAreaType.id) {
            this.zoomOut();
            return;
        }


        let model = this.getAreaFilters();

        this.mapService.filterAreaMap(model).finally(() => setTimeout(() => this.loading = false)).subscribe(
            response => {
                let data = response.programs;
                this.addMarkers(data);
                this.chartPrograms = data;
            }
        );
    }

    getAreaFilters(): AreaMapRequest {

        let programs = this.getProgramFilterIds();
        let grades = this.getGradeFilterIds();

        let model: AreaMapRequest = {
            programsOffered: programs,
            id: this.areaId,
            grades: grades,
            areaType: this.selectedAreaType.id
        };

        return model;
    }

    updateMarkersFromTable() {
        this.removeMarkers();
        this.addMarkers(this.chartPrograms);
    }

    addMarkers(data: MapProgram[]): void {
        data.forEach(x => {
            let latlng = new google.maps.LatLng({ lat: +x.lat, lng: +x.lng });

            let marker = new google.maps.Marker({
                position: latlng,
                title: x.name,
                icon: this.mapIcons[x.selected ? "pinRed" : "pinGreen"].icon
            });
            marker.actnow = {
                id: x.id,
                name: x.name,
                websiteUrl: x.websiteUrl,
                phoneNumber: x.phoneNumber,
                address: x.address,
                lat: +x.lat,
                lng: +x.lng,
            };

            this.addAreaMarkerClickListener(marker);

            marker.setMap(this.map);
            this.markers.push(marker);
        });
    }

    removeMarkers(): void {
        this.markers.forEach(x => {
            x.setMap(null);
        });
        this.markers = [];
        this.removeMarkerListeners();
    }

    openInfoWindowForMarker(marker: any) {
        this.closeStateInfoWindow();
        this.closeAreaInfoWindow();

        let data = marker.actnow;
        marker.setIcon(this.mapIcons["pinRed"].icon);
        this.chartPrograms.forEach(x => {
            x.selected = false;
        });
        let program = this.chartPrograms.find(x => x.id === data.id).selected = true;

        let pos = new google.maps.LatLng({ lat: data.lat, lng: data.lng });
        let content = "<div id='content'>";
        content += "<h1 class='program-heading'>";
        content += "<a href='/public-profile/" + data.id + "' class='public-profile-click-target' data-program-id='" + data.id + "'>";
        content += data.name;
        content += "</a></h1>";
        if (data.websiteUrl != undefined) {
            content += "<p>Website: <a href='" + data.websiteUrl + "' target='_blank'>" + data.websiteUrl + "</a></p>";
        }
        if (data.phoneNumber != undefined) {
            content += "<p>Phone Number: " + data.phoneNumber + "</p>";
        }
        content += "<p>Address: " + data.address + "</p>";
        content += "<p><a href='/public-profile/" + data.id + "' class='public-profile-click-target' data-program-id='" + data.id + "'>";
        content += "more details";
        content += "</a></p>";
        content += "</div>";

        this.areainfowindow.setContent(content);
        this.areainfowindow.setPosition(pos);
        this.areainfowindow.open(this.map);

        this.addAreaJQueryPopoverListeners();
    }

    closeAreaInfoWindow(): void {
        this.areainfowindow.close();
        this.onAreaInfoWindowClose();
        this.removeAreaJQueryPopoverListeners();
    }

    onAreaInfoWindowClose(): void {
        if (this.chartPrograms && this.zoomedIn) {
            let green = this.mapIcons["pinGreen"].icon;
            this.markers.forEach(x => {
                x.setIcon(green);
            });
            this.chartPrograms.forEach(x => {
                x.selected = false;
            });
        }
    }

    addAreaJQueryPopoverListeners() {
        jQuery(".public-profile-click-target").on("click", (e) => {
            e.preventDefault();
            let id = +jQuery(e.target).data().programId;
            this.navigateToPublicProfile(id);
        });
    }

    removeAreaJQueryPopoverListeners() {
        jQuery(".public-profile-click-target").off("click");
    }

    updateRowCount(): void {
        this.mapRows = +this.rowCount;
        setTimeout(() => this.dtp.updateRows());
    }

    openInfoWindowForProgram(id: number) {
        let marker = this.markers.find(x => x.actnow.id === id);
        this.openInfoWindowForMarker(marker);
    }

    goToPublicProfile(event, id: number) {
        event.preventDefault();
        id = +id;
        this.navigateToPublicProfile(id);
    }

    getFilters(): AreaMapRequest {
        let programs = this.getProgramFilterIds();
        let grades = this.getGradeFilterIds();

        let model = new AreaMapRequest();

        if (this.zoomedIn) {
            model.id = this.areaId;
        }

        model.programsOffered = this.getProgramFilterIds();
        model.grades = this.getGradeFilterIds();
        model.areaType = this.selectedAreaType.id;

        //todo: add map filters?

        return model;
    }

    navigateToPublicProfile(id: number) {
        let model = this.getFilters();
        localStorage.setItem("map-filters", JSON.stringify(model));
        this.router.navigate(["public-profile", id]);
    }

    updateMapFromSearchbar(filter: AreaMapRequest) {
        setTimeout(() => this.loading = true);
        if (this.selectedAreaType.id !== filter.areaType) {
            this.handleAreaChange(filter.areaType);
            this.areaSelectize[0].selectize.setValue(this.selectedAreaType.id, false);
        }

        if (this.selectedAreaType.id !== this.currentAreaType.id) {
            if (this.zoomedIn) {
                this.zoomedIn = false;
                this.removeMarkers();
                this.closeAreaInfoWindow();
                this.currentAreaType = this.selectedAreaType;
                setTimeout(() => {
                    this.map.data.forEach(x => {
                        this.map.data.remove(x);
                    });
                    this.map.setCenter(this.valueService.mapCenter);
                    this.map.setZoom(this.valueService.stateZoom);
                    this.getShapes(this.attemptZoomIn(filter.id));
                });
            } else {
                this.hideLegend = true;
                this.closeStateInfoWindow();
                this.map.data.forEach(x => {
                    this.map.data.remove(x);
                });

                this.currentAreaType = this.selectedAreaType;
                this.getShapes(this.attemptZoomIn(filter.id));
            }
        } else {
            if (this.zoomedIn) {
                if (this.areaId === filter.id) {
                    setTimeout(() => this.loading = false);
                    return;
                }

                this.zoomedIn = false;
                this.removeMarkers();
                this.closeAreaInfoWindow();
                setTimeout(() => {
                    this.map.data.forEach(x => {
                        this.map.data.remove(x);
                    });
                    this.map.setCenter(this.valueService.mapCenter);
                    this.map.setZoom(this.valueService.stateZoom);
                    this.getShapes(this.attemptZoomIn(filter.id));
                });
            } else {
                this.zoomIn(filter.id);
            }
        }
    }
}




// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/map/map.component.ts